//@ts-nocheck
import React, { useEffect, useMemo, useState } from "react";
import {
    Box,
    FormControl,
    useMediaQuery,
    useTheme,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import { Button, Loading } from "../../atoms";
import { InputControl, SelectControl, SwitchControl } from "../../molecules";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";

import {
    useGetCommissionProfileList,
    useGetInstallmentCountSettingsList,
    useGetAllMerchantList,
    useGetAcquirerBankList,
    useGetPayment3DTrxSettingsList,
    useUpdateCommissionParameter,
    useAuthorization,
    useGetMemberVPosList,
    useGetCardBrandsList,
    PagingResponse,
    useGetAllSectors,
    usePostAddSector,
    useDeleteSector
} from "../../../hooks";
import { sectorAddFormSchema, sectorAddFormSchemaFormValuesType, sectorAddInitialValues } from "./_formTypes";

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import {
    GridColDef,
    GridRowId,
    GridRenderCellParams,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
} from "@mui/x-data-grid";
import { Table, DeleteConfirmModal } from "../../molecules";


function AddSectorSection({ setPaginationModel, requestReloadTable }) {

    const [sectorName, setSectorName] = useState('');
    const { mutate: addSector, isLoading: isAddSectorLoading } = usePostAddSector();

    const saveSector = () => {
        if (sectorName === '') {
            return;
        }

        addSector({
            sectorName: sectorName
        }, {
            onSuccess: (data) => {
                requestReloadTable()
                setSectorName('');
            },
            onError: (error) => {
            }
        })
    };

    return (
        <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 600, alignSelf: 'center' }}
        >
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Sektör Adı"
                inputProps={{ 'aria-label': 'Sektör Adı' }}
                value={sectorName}
                onChange={(value) => {
                    setSectorName(value.target.value);
                }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <Stack sx={{ p: '10px' }}>
                <Button onClick={saveSector} sx={{ mx: 2 }} text={"Ekle"} disabled={isAddSectorLoading} />
            </Stack>
        </Paper>
    );
}

function SectorListing({ isDesktop, paginationModel, setPaginationModel, requestReloadTable, reloadTable, setReloadTable }) {

    const navigate = useNavigate();

    const { mutate: getAllSectors, isLoading: isSectorsLoading } = useGetAllSectors();

    const [queryOptions, setQueryOptions] = React.useState({});

    const [tableData, setTableData] =
        useState<PagingResponse<Array<any>>>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const columns = [
        {
            field: "Aksiyonlar",
            type: "actions",
            width: 80,
            getActions: (params) => [
                <GridActionsCellItem
                    label="Sil"
                    onClick={deleteRow(params.row)}
                    showInMenu
                />,
            ],
        },
        { field: "id", headerName: "Id", width: 200 },
        { field: "sectorName", headerName: "Sektör Adı", width: 200 },
    ];

    const editRow = React.useCallback(
        (commissionProfile: ICommissionProfileForPage) => () => {
            // navigate("/commission-management/commission-codedefinition-detail", {
            //     state: commissionProfile,
            // });
        },
        [navigate]
    );

    const [selectedRowId, setSelectedRowId] = React.useState<number | null>(null);

    const deleteRow = React.useCallback(
        (commission: any) => () => {
            setIsDeleteModalOpen(true);
            setSelectedRowId(Number(commission.id));
        },
        []
    );

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const getQueryParams = (filters) => {
        const queryParams = {};

        for (let key in filters) {
            if (filters[key]?.toString()?.length >= 1) {
                queryParams[key] = filters[key];
            }
        }

        return queryParams;
    };

    const handleFilterChange = debounce((filters) => {
        if (filters.clearFilter) {
            localStorage.removeItem('sectorListingFilter')
            return setQueryOptions({});
        }

        const queryParams = getQueryParams(filters);
        const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
        const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        // Eğer queryParams bir önceki ile aynıysa işlem yapma
        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
            setQueryOptions(queryParams);
            localStorage.setItem('sectorListingFilter', JSON.stringify(queryParams))
        }

        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);

    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

    const previousQueryParams = React.useRef({});

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
        setTableData(undefined);
        requestReloadTable();
    };

    const { mutate: deleteSector, isLoading: isDeleteLoading } =
        useDeleteSector();

    const handleDeleteConfirm = () => {
        const deleteRequest = {
            id: selectedRowId,
        };

        deleteSector(deleteRequest, {
            onSuccess: (data: any) => {
                if (data.isSuccess) {
                    setReloadTable(true);
                    setSnackbar({
                        severity: "success",
                        isOpen: true,
                        description: data.message,
                    });
                } else {
                    setSnackbar({
                        severity: "error",
                        description: data.message,
                        isOpen: true,
                    });
                }
            },
            onError: () => {
                setSnackbar({
                    severity: "error",
                    description: "İşlem sırasında bir hata oluştu",
                    isOpen: true,
                });
            },
        });

        handleCloseDeleteModal();
    };

    useEffect(() => {

        getAllSectors({
            page: paginationModel.page,
            size: paginationModel.pageSize,
            orderByDesc: true,
            status: 'ACTIVE',
            ...queryOptions,
        }, {
            onSuccess: (data) => {
                setTableData(data?.data?.result);
            },
            onError: (error) => {

            }
        })

        setReloadTable(false);

    }, [reloadTable, queryOptions]);



    return (<>
        {isSectorsLoading && <Loading />}
        <Stack sx={{ paddingTop: 1.5, display: 'flex' }}>
            {tableData && <Table
                columnVisibilityConfigKey="sectorListingColumnVisibilityKey"
                filterKey="sectorListingFilter"
                hasActiveFilters={hasActiveFilters}
                handleFilterChange={handleFilterChange}
                paginationModel={paginationModel}
                onPaginationModelChange={handleChangePagination}
                paginationMode="server"
                rowCount={tableData?.totalItems || 0}
                onRowClick={() => { }}
                isRowSelectable={() => false}
                // disableColumnMenu
                rows={tableData || []}
                columns={columns}
                exportFileName="Sektör Listesi"
                onSave={() => onSave()}
            />}
            <DeleteConfirmModal
                isOpen={isDeleteModalOpen}
                onClose={handleCloseDeleteModal}
                onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
        </Stack>
    </>);
};

export const SectorManagementForm = () => {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const setSnackbar = useSetSnackBar();

    const {
        control,
        watch,
        reset,
        handleSubmit,
        setValue,
        getValues
    } = useForm<sectorAddFormSchemaFormValuesType>({
        resolver: zodResolver(sectorAddFormSchema),
        defaultValues: sectorAddInitialValues,
    });

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 25,
    });

    const [reloadTable, setReloadTable] = useState(false);

    const requestReloadTable = () => {

        setReloadTable(true);

    }

    return <>
        <Stack flex={1} p={2}>
            <AddSectorSection setPaginationModel={setPaginationModel} requestReloadTable={requestReloadTable} />
            <Divider orientation="horizontal" sx={{ width: '100%', m: 0.5, padding: 1.5 }} />
            <SectorListing isDesktop={isDesktop} paginationModel={paginationModel} setPaginationModel={setPaginationModel} requestReloadTable={requestReloadTable} reloadTable={reloadTable} setReloadTable={setReloadTable} />
        </Stack>
    </>
};